import React from "react";
import ReactDOM from "react-dom";
import "./init.js";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import "izitoast/dist/css/iziToast.min.css";
import { routerFuture } from "./routes/routerFuture";

ReactDOM.render(
  <Router future={routerFuture}>
    <App />
  </Router>,
  document.getElementById("root")
);
